<template>
  <div :class="[total == 0 ? 'hidden' : '', 'pagination-container']">
    <el-button type="button"
               @click="jumpFirstPage"
               class="btn">首页</el-button>
    <el-pagination ref="pagination"
                   prev-text='上一页'
                   next-text='下一页'
                   :page-size="size"
                   :pager-count="7"
                   layout="prev, pager, next"
                   :total="total"
                   :current-page="page"
                   @current-change="handleCurrentChange"
                   style="display: inline-block;">
    </el-pagination>
    <el-button type="button"
               @click="jumpLastPage"
               class="btn">末页</el-button>
    <div class="page">{{page}}/{{cpage}}</div>
    <div class="total">共<span class="totalNumber">{{total}}</span>条数据</div>
  </div>
</template>
<script>

export default {
  name: 'pagination',
  props: {
    total: {
      required: true,
      type: Number
    },
    size: {
      required: true,
      type: Number
    },
    page: {
      required: true,
      type: Number
    },
  },
  data () {
    return {
      cpage: '',
    }
  },
  computed: {},
  created () {
    this.cpage = Math.ceil(this.total / this.size);
    console.log('this.total=>', this.total)
    console.log('this.size=>', this.size)
  },
  methods: {
    jumpFirstPage () {
      this.$refs.pagination.handleCurrentChange(1);
      this.$emit('handleCurrentChange', 1);
    },
    jumpLastPage () {
      let font = this.$refs.pagination
      let cpage = Math.ceil(font.total / font.pageSize);
      font.handleCurrentChange(cpage);
    },
    handleCurrentChange (val) {
      this.$emit('pagination', val)
    }
  }
}
</script>

<style lang='less' scoped>
.page {
  color: rgba(255, 255, 255, 0.5);
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: 10px;
}
.total {
  color: rgba(255, 255, 255, 0.5);
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 200px;
  height: 30px;
  margin-left: 20px;
}
.totalNumber {
  color: #00fffe;
  padding: 0 5px;
}
.hidden {
  display: none !important;
}
.pagination-container {
  position: absolute;
  bottom: 63px;
  left: 50%;
  transform: translate(-50%);
  display: flex;
  align-items: center;
  .btn {
    width: 60px;
    height: 40px;
    padding: 0;
    font-size: 24px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.5);
    // background: linear-gradient(90deg, #180768, #0E0736);
    background: linear-gradient(90deg, #064085, #0e69e4);
    border: 1px solid;
    border-image: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0.5),
        rgba(74, 144, 226, 0.5)
      )
      1 1;
  }
}
//
/deep/.el-pagination .el-pager li.active {
  font-weight: 400;
  color: #ffffff;
  background: #07111e;
  padding: 20px 9px;
  /* display: flex; */
  line-height: 3px;
}
/deep/ .el-pagination {
  padding: 0;
  .btn-prev,
  .btn-next {
    padding: 0;
    width: 100px;
    height: 40px;
    // background: linear-gradient(90deg, #180768, #0E0736);
    background: linear-gradient(90deg, #064085, #0e69e4);
    border: 1px solid;
    border-image: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0.5),
        rgba(74, 144, 226, 0.5)
      )
      1 1;
    span {
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.5);
    }
  }
  .btn-prev {
    margin-left: 20px;
    margin-right: 30px;
  }
  .btn-next {
    margin-left: 30px;
    margin-right: 20px;
  }
  .el-pagination .el-pager li {
    font-size: 24px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.5);
  }
  .el-pager li.active {
    font-weight: 400;
    color: #ffffff;
  }
  .el-pager li:hover {
    color: #ffffff;
  }
  .el-dialog,
  .el-pager li {
    background: none;
    line-height: 40px;
    font-size: 24px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.5);
  }
  .el-pager li {
    padding: 0 20px;
  }
  .el-pager {
    height: 40px;
  }
  // .el-icon-d-arrow-left:before{
  //     content: "\e794";
  // }
}
</style>